export default __webpack_public_path__ + "static/media/stormfield.fe7553cf.png";